// ⚠️ Do not edit ⚠️
// This file is automagically generated
// See codegen.yml under `graphql-codegen`
export type JSONType = null | string | boolean | number | JSONType[] | { [key: string]: JSONType }


      export type PossibleTypesResultData = {
  "possibleTypes": {
    "Attribute": [
      "BaseAttribute",
      "MoneyAttribute",
      "ProductAttribute",
      "ProductsWithQuantityAttribute"
    ],
    "BlockType": [
      "Block",
      "GalleryBlock",
      "PageGridBlock",
      "ProductGridSelectorBlock",
      "ProductListBlock"
    ],
    "BlockTypeWithGlobal": [
      "Block",
      "GalleryBlock",
      "GlobalBlock",
      "PageGridBlock",
      "ProductGridSelectorBlock",
      "ProductListBlock"
    ],
    "Field": [
      "FilterField",
      "ProductField",
      "JSONField",
      "LinkField",
      "ReferenceField",
      "RTEField",
      "ObjectField"
    ],
    "IAttribute": [
      "BaseAttribute",
      "MoneyAttribute",
      "ProductAttribute",
      "ProductsWithQuantityAttribute"
    ],
    "IBlock": [
      "Block",
      "GalleryBlock",
      "GlobalBlock",
      "PageGridBlock",
      "ProductGridSelectorBlock",
      "ProductListBlock"
    ],
    "IField": [
      "FilterField",
      "JSONField",
      "LinkField",
      "ObjectField",
      "ProductField",
      "RTEField",
      "ReferenceField"
    ],
    "IReference": [
      "EmailVariable",
      "ExternalLink",
      "ImageResource",
      "Page",
      "VideoResource"
    ],
    "IWithAssets": [
      "LineItem",
      "Product"
    ],
    "IWithBlocks": [
      "Email",
      "EmailLayoutFooter",
      "EmailLayoutHeader",
      "Page"
    ],
    "IWithBrand": [
      "Page",
      "Product"
    ],
    "IWithCategories": [
      "Product"
    ],
    "IWithFields": [
      "Bar",
      "Block",
      "Email",
      "GalleryBlock",
      "GalleryBlockSlide",
      "GlobalBlock",
      "ImageResource",
      "Page",
      "ProductGridSelectorBlock",
      "ProductListBlock"
    ],
    "IWithImages": [
      "GalleryBlockSlide"
    ],
    "IWithMoney": [
      "Money",
      "Price",
      "PriceDiscount"
    ],
    "IWithProduct": [
      "AddToCartLegacyFailedProduct",
      "LineItem",
      "ProductField",
      "ProductInCart",
      "ProductWithPersonalizationType",
      "ProductWithQuantity",
      "UVProduct"
    ],
    "IWithProducts": [
      "AddToCartLegacyAddedProducts",
      "ComplementaryRecommendations",
      "LinkedProduct",
      "ProductAttribute",
      "Recommendations",
      "UserRecommendations"
    ],
    "IWithReferences": [
      "CaptionOptions",
      "LinkField",
      "PageGridBlock",
      "ProductListBlock",
      "RTEField",
      "ReferenceField"
    ],
    "Me": [
      "Employee",
      "Service"
    ],
    "Media": [
      "ImageResource",
      "VideoResource"
    ],
    "Reference": [
      "EmailVariable",
      "ExternalLink",
      "ImageResource",
      "Page",
      "VideoResource"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Attribute": [
      "BaseAttribute",
      "MoneyAttribute",
      "ProductAttribute",
      "ProductsWithQuantityAttribute"
    ],
    "BlockType": [
      "Block",
      "GalleryBlock",
      "PageGridBlock",
      "ProductGridSelectorBlock",
      "ProductListBlock"
    ],
    "BlockTypeWithGlobal": [
      "Block",
      "GalleryBlock",
      "GlobalBlock",
      "PageGridBlock",
      "ProductGridSelectorBlock",
      "ProductListBlock"
    ],
    "Field": [
      "FilterField",
      "ProductField",
      "JSONField",
      "LinkField",
      "ReferenceField",
      "RTEField",
      "ObjectField"
    ],
    "IAttribute": [
      "BaseAttribute",
      "MoneyAttribute",
      "ProductAttribute",
      "ProductsWithQuantityAttribute"
    ],
    "IBlock": [
      "Block",
      "GalleryBlock",
      "GlobalBlock",
      "PageGridBlock",
      "ProductGridSelectorBlock",
      "ProductListBlock"
    ],
    "IField": [
      "FilterField",
      "JSONField",
      "LinkField",
      "ObjectField",
      "ProductField",
      "RTEField",
      "ReferenceField"
    ],
    "IReference": [
      "EmailVariable",
      "ExternalLink",
      "ImageResource",
      "Page",
      "VideoResource"
    ],
    "IWithAssets": [
      "LineItem",
      "Product"
    ],
    "IWithBlocks": [
      "Email",
      "EmailLayoutFooter",
      "EmailLayoutHeader",
      "Page"
    ],
    "IWithBrand": [
      "Page",
      "Product"
    ],
    "IWithCategories": [
      "Product"
    ],
    "IWithFields": [
      "Bar",
      "Block",
      "Email",
      "GalleryBlock",
      "GalleryBlockSlide",
      "GlobalBlock",
      "ImageResource",
      "Page",
      "ProductGridSelectorBlock",
      "ProductListBlock"
    ],
    "IWithImages": [
      "GalleryBlockSlide"
    ],
    "IWithMoney": [
      "Money",
      "Price",
      "PriceDiscount"
    ],
    "IWithProduct": [
      "AddToCartLegacyFailedProduct",
      "LineItem",
      "ProductField",
      "ProductInCart",
      "ProductWithPersonalizationType",
      "ProductWithQuantity",
      "UVProduct"
    ],
    "IWithProducts": [
      "AddToCartLegacyAddedProducts",
      "ComplementaryRecommendations",
      "LinkedProduct",
      "ProductAttribute",
      "Recommendations",
      "UserRecommendations"
    ],
    "IWithReferences": [
      "CaptionOptions",
      "LinkField",
      "PageGridBlock",
      "ProductListBlock",
      "RTEField",
      "ReferenceField"
    ],
    "Me": [
      "Employee",
      "Service"
    ],
    "Media": [
      "ImageResource",
      "VideoResource"
    ],
    "Reference": [
      "EmailVariable",
      "ExternalLink",
      "ImageResource",
      "Page",
      "VideoResource"
    ]
  }
};
      export default result;
    